// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.Toastify__toast-container--bottom-right {\n    width: 510px;\n}", "",{"version":3,"sources":["webpack://src/components/pages/claimant-folders/claimant-profile/toastOverrideWidth.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB","sourcesContent":["\n.Toastify__toast-container--bottom-right {\n    width: 510px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
